<template>
    <div>
        <b-modal id="success_freegift_modal"
                 modal-class="modal-freegift-success"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">

                <div class="img-logo-modal">
                    <img src="@/assets/icon/logo-popup@3x.png" />
                </div>

                <div class="modal-base-body">
                    <div class="head">{{lbl.gift_detail.thank_redeem_freegift}}</div>

                    <div class="item">{{lbl.gift_detail.confirm_redeem.name}} {{information.username}}</div>
                    <div class="item" v-if="information.branchName">{{lbl.gift_detail.confirm_redeem.branch}} {{information.branchName}}</div>
                    <div class="item">{{lbl.gift_detail.confirm_redeem.gift}} {{information.campaignName}}</div>
                </div>

                <div class="modal-base-footer btn-redeem-wrapper">
                    <div>
                        <button class="btn btn-confirm" @click="clickUse()">{{lbl.gift_detail.use_code_now}}</button>
                    </div>
                    <div>
                        <button class="btn btn-cancel" @click="hideModal()">{{lbl.gift_detail.close}}</button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>

export default {
    name: "ConditionModal",
    props: {
        busModal: Object,
        view: String,
        lbl: Object,
    },
    data: function() {
        return {
            modalSuccess: {

                title: '',
                strBtnOk: '',
                message: '',
                tag: '',
            },

            information: {}
        };
    },
    created: function() {

    },
    mounted: function() {

        this.busModal.$on('showModal', this.showModal);
    },
    methods: {
        showModal: function(dataRedeem) {
            console.log("dataRedeem", dataRedeem);
            this.information = dataRedeem;

            this.$bvModal.show('success_freegift_modal');
        },
        hideModal: function() {

            this.$bvModal.hide('success_freegift_modal');
        },
        clickUse: function () {

            this.$emit('clickUse');
            this.hideModal();
        },
        clickContinue: function() {
            this.hideModal();
            if (this.modalSuccess.tag == "success") {
                this.$router.push('/profile');
            }

        },
    },
}
</script>
<style lang="scss" scoped>
    #success_freegift_modal {

        .modal-base {

            .img-logo-modal {
                padding-top: 30px;
                padding-bottom: 30px;
                img {
                    width: 130px;
                }
            }
            .modal-base-body {

                padding-bottom: 50px;
                font-size: 15px;
                line-height: 1.5;

                .head {
                    font-size: 20px;
                    padding-top: 20px;
                    padding-bottom: 20px;
                }
                .item {
                    color: #000000;
                    font-size: 12px;
                    padding-bottom: 8px;
                }
            }
            .btn-redeem-wrapper {

                text-align: center;
                margin: 0px 40px;

                .btn-confirm {
                    margin-bottom: 16px;
                    width: 100%;
                    background-color: black;
                    color: white;
                    border-color: black;
                    border-radius: 0;
                    min-height: 50px;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                }
                .btn-cancel {
                    width: 100%;
                    background-color: white;
                    color: black;
                    border-color: black;
                    border-radius: 0;
                    height: 46px;
                    text-transform: uppercase;
                    letter-spacing: 2px;
                }
            }
        }
    }
</style>
<style lang="scss">
.modal-freegift-success {

    .modal-dialog {

        .modal-content {

            max-width: 100%;
            margin: 20px;
            line-height: 1.2;
            text-align: center;
        }
    }
}
#success_freegift_modal {
    .modal-body {
        padding-bottom: 30px;
    }

}
</style>
